export class SignUpReportQueryDto {
  startDate?: Date;
  endDate?: Date;
  page?: number;
  limit?: number;
}
